const GlobalStyles = `
  .editorial-body {
    background-color: var(--nts-black);
    margin: 0;
    padding: 0;
  }

  .editorial {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-top: -68px;
  }

  .editorial button {
    cursor: pointer;
  }

  .editorial audio,
  .editorial canvas,
  .editorial iframe,
  .editorial img,
  .editorial svg,
  .editorial video {
    vertical-align: middle;
  }

  @media(min-width: 768px) {
    .editorial {
      margin-top: -24px;
    }
  }

  @media(min-width: 1025px) {
    .editorial {
      margin-top: 76px;
    }
  }
`

export default GlobalStyles
